import { Injectable, EventEmitter } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, Subject } from 'rxjs';
import { map } from 'rxjs/operators';
import { Account } from '../models/account';
import { environment } from '../../environments/environment';
import { HttpResponseInterface } from '../interfaces/iHttpResponse';
import { iHttpPaginatedResponse } from '../interfaces/iHttpPaginatedResponse';

@Injectable({
  providedIn: 'root'
})

export class AccountService {
    private account: Account;
    public accountChanged = new EventEmitter<any>();
    constructor(private http: HttpClient) {
        this.account = this.getLocalAccount();
    }

    public getApplications(page, pp, filters):Observable<iHttpPaginatedResponse>{
      return this.http.get<iHttpPaginatedResponse>(environment.apiEndpoint+`/api/account/applications?page=${page}&pp=${pp}&${filters}`).pipe(
        map(
          res=>{
            return res;
          }
        )
      );
    }

    public getApplication(id):Observable<any>{
      return this.http.get(environment.apiEndpoint+`/api/account/applications/${id}`).pipe(
        map(
          res=>{
            return res;
          }
        )
      );
    }

    public addApplicationNote(id, note:string):Observable<any>{
      return this.http.post(environment.apiEndpoint+`/api/account/application/${id}/note`, {note:note}).pipe(
        map(
          res=>{
            return res;
          }
        )
      );
    }

    public rejectApplication(id):Observable<any>{
      return this.http.put(environment.apiEndpoint+`/api/account/application/reject`, {id:id}).pipe(
        map(res=>{
          return res;
        })
      );
    }

    public approveApplication(id):Observable<any>{
      return this.http.put(environment.apiEndpoint+`/api/account/application/approve`, {id:id}).pipe(
        map(res=>{
          return res;
        })
      );
    }

    public toggleApplicationContacted(appId:number, status:number):Observable<any>{
      return this.http.put(environment.apiEndpoint+`/api/account/applicationContacted`, {appId:appId,status:status}).pipe(
        map(
          res=>{
            return res;
          }
        )
      );
    }

    public updateBillingDetails(application:any):Observable<any>{
      return this.http.put(environment.apiEndpoint+`/api/account/application/billing`, {application:application}).pipe(
        map(
          res=>{
            return res;
          }
        )
      );
    }

    public saveAccount(account: Account): Observable<any> {
        return this.http.put<HttpResponseInterface>(environment.apiEndpoint + `/api/userAdmin`, account).pipe(
            map(res => {
                this.setLocalAccount(res);
                this.accountChanged.emit();
                return res;
            })
        );
    }

    public savePassword(newPassword:string, confirmPassword:string, currentPassword:string){
        return this.http.post<any>(environment.apiEndpoint + `/api/user/password`, {'password':newPassword, 'confirmPassword':confirmPassword, 'currentPassword':currentPassword}).pipe(
            map(res => {
                return res;
            })
        );
    }

    public recoverAccount(emailAddress:string){
        return this.http.get<any>(environment.apiEndpoint + `/api/user/recoverAdmin/${emailAddress}`).pipe(
            map(res => {
                return res;
            })
        );
    }

    public getMyAccount():Observable<Account>{
        return this.http.get<any>(environment.apiEndpoint + `/api/user`).pipe(
            map(res => {
                return res.user;
            })
        );
    }

    public setLocalAccount(account){
        localStorage.setItem('account',JSON.stringify(account));
        this.accountChanged.emit();
    }

    public getLocalAccount(){
        return JSON.parse(localStorage.getItem('account'));
    }

    public confirmPasswordReset(key, password, confirmPassword){
        return this.http.post<any>(environment.apiEndpoint + `/api/user/recover/confirm/${key}`, {'password':password, 'confirmPassword':confirmPassword}).pipe(
            map(res => {
                return res;
            })
        );
    }

    public completeRegistration(user:Account, token):Observable<any>{
        return this.http.post<any>(environment.apiEndpoint + `/api/register/${token}`, user).pipe(
            map(res => {
                return res;
            })
        );
    }

    public getByRegistrationToken(token):Observable<any>{
        return this.http.get<any>(environment.apiEndpoint + `/api/register/${token}`).pipe(
            map(res => {
                return res;
            })
        );
    }

    public checkUserCourseAccess(course_id:number){
        return this.http.get<any>(environment.apiEndpoint + `/api/user/access/${course_id}`).pipe(
            map(res => {
                return res;
            })
        );
    }

    public getCurrentPoints():number{
        const localAccount = this.getLocalAccount();
        let points = 0;
        if(localAccount.points && localAccount.points.length!=0){
            var date = new Date();
            var year = date.getFullYear();

            localAccount.points.forEach(record=>{
                if(record.year==year){
                    points= record.points;
                }
            })
        }
        return points;
    }

    public resendVerificationEmail(memberId:number):Observable<any>{
      return this.http.put(environment.apiEndpoint+'/api/admin/resend-verification', {memberId:memberId}).pipe(
        map(
          res=>{
            return res;
          }
        )
      );
    }
}
